let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("54Ij5")).then(() => parcelRequire('fxoyS'));